import styled, { keyframes, css } from 'styled-components';
import Colors from 'library/constants/colors';
import ClickOutside from 'library/components/click-outside';
import { ButtonSecondaryStyles } from 'library/styles/button';
import { ShadowElevation, TransitionConfig } from '../../constants/styles-config';

export const rotation = keyframes`
  0% {
    transform: rotate(0);
  } 
  100% {
    transform: rotate(360deg);
  }
`;

export const Info = styled.div`
  background-color: ${Colors.violetLight} !important;
  color: ${Colors.shade08} !important;
  padding: 15px;
  position: relative;
  border-radius: 5px;
  max-width: 220px;
  
  :after, :before {
    top: 100%;
    right: 15px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  :after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color:  ${Colors.violetLight};
    border-width: 10px;
    margin-left: -10px;
  }

  :before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color:  ${Colors.violetLight};
    border-width: 16px;
    margin-left: -16px;
  }
`;

export const Icon = styled.i`
  color: ${Colors.shade08};
  margin-bottom: 3px;
  margin-top: 4px;
`;

const loadAnimation = () => css`
  animation: ${rotation} 2s linear infinite;
`;

export const Button = styled.button`
  width: 60px;
  height: 60px;
  //background: ;
  background: ${({ isLoading, disabled }) => (isLoading || disabled ? 'unset' : `linear-gradient(84.35deg, ${Colors.violet} 0%, ${Colors.blueLight} 100%)`)};
  border: 2px solid ${Colors.shade08};
  box-sizing: border-box;
  box-shadow: ${ShadowElevation};
  border: 2px solid ${Colors.shade08};
  border-radius: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  background-color: ${({ isLoading }) => (isLoading ? Colors.shade09 : 'inherit')};

  ${Icon} {
    font-size: 40px;
    margin-top: ${({ disabled, isLoading }) => (disabled && !isLoading ? '0' : '4px')};
    ${({ isLoading }) => (isLoading ? loadAnimation : '')}
  }

  &:disabled {
    ${({ isLoading, disabled }) => (!isLoading && disabled ? `background-color: ${Colors.violet}` : '')};
  }

  &:hover {
 
    &:not(:disabled) {
      background: ${Colors.violet};
    }
  }
`;

export const ActionButton = styled.button`
  ${ButtonSecondaryStyles};
  font-size: 15px;
  width: 240px;
  height: 48px;
  border-width: 0;
  display: flex;
  justify-content: start;
  color: ${Colors.shade01};

  ${Icon} {
    font-size: 30px;
    color: #6C52A2;
    transition: color ${TransitionConfig};
  }
  
  :disabled {
    background-color: #7F8C90 !important;
    color: ${Colors.shade05} !important;
  }
  
  :hover {
    color: #fff;

    &:not(:disabled) {
      ${Icon} {
        color: #fff;
      }
    } 
  }
`;

export const StyledClickOutside = styled(ClickOutside)`
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: ${({ isShifted }) => (isShifted ? 'none' : 'flex')};
  z-index: 23;
  align-items: flex-end;
  flex-direction: column;
  transition: right 0.25s ease-in-out;
`;

export const Container = styled.div`
  position: fixed;
  bottom: 40px;
  right: ${({ isShifted }) => (isShifted ? '580px' : '40px')};
  z-index: 9;
  display: flex;
  align-items: end;
  flex-direction: column;
  opacity: 1;
  //transition: right 0.25s ease-in-out;
  
  ${Button} {
    display: ${({ isShifted }) => (isShifted ? 'none' : 'flex')};
  }

  ${Info} {
    display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
  }
`;

export const ActionsContainer = styled.div`
  opacity: 0;
`;
